import { useDisclosure } from "@mantine/hooks";

export function useMobileNavbar() {
  const [opened, { toggle, close }] = useDisclosure();

  return {
    opened,
    toggle,
    close,
    navbar: {
      width: 300,
      breakpoint: "sm" as const,
      collapsed: { mobile: !opened },
    },
  };
}
